import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { firestore } from '../config/firebaseConfig';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import './PilulaDetails.css';

function PilulaDetails() {
  const { id } = useParams(); // Obtendo o parâmetro da URL
  const [pilula, setPilula] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const fetchPilula = async () => {
      try {
        const docRef = doc(firestore, 'pilulas', id); // Referência ao documento específico
        const docSnap = await getDoc(docRef); // Obtendo o documento
        if (docSnap.exists()) {
          setPilula({ id: docSnap.id, ...docSnap.data() }); // Armazenando os dados da pílula
          setFormData({ ...docSnap.data() }); // Configurando os dados do formulário
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Erro ao buscar pílula educacional:', error);
      } finally {
        setLoading(false); // Indicando que o carregamento foi concluído
      }
    };

    fetchPilula(); // Chamada da função para buscar a pílula ao montar o componente
  }, [id]); // Executando sempre que o parâmetro 'id' da URL mudar

  const handleEditToggle = () => {
    setIsEditing(!isEditing); // Alternando o modo de edição
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value }); // Atualizando os dados do formulário
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(firestore, 'pilulas', id); // Referência ao documento específico
      const updatedData = {
        ...formData,
        updatedAt: new Date().toISOString(),
      };

      await updateDoc(docRef, updatedData); // Atualizando o documento no Firestore
      setPilula({ ...pilula, ...updatedData }); // Atualizando os dados da pílula exibida
      setIsEditing(false); // Saindo do modo de edição
    } catch (error) {
      console.error('Erro ao atualizar pílula educacional:', error);
    }
  };

  const calculateCompletionPercentage = () => {
    const totalFields = Object.keys(formData).length;
    const filledFields = Object.values(formData).filter(value => value && value.trim() !== '').length;
    return Math.round((filledFields / totalFields) * 100); // Calculando a porcentagem de preenchimento do formulário
  };

  if (loading) return <p>Carregando...</p>; // Exibindo mensagem de carregamento enquanto os dados são obtidos

  const completionPercentage = calculateCompletionPercentage(); // Calculando a porcentagem de preenchimento

  return (
    <div className="pilula-details-container">
      {pilula ? (
        <>
          {isEditing ? (
            <form onSubmit={handleFormSubmit}>
              <h1>{pilula.title ? 'Editar Pílula Educacional' : 'Adicionar Nova Pílula Educacional'}</h1>
              <label>
                Título:
                <input
                  type="text"
                  name="title"
                  value={formData.title || ''}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Tipo:
                <input
                  type="text"
                  name="type"
                  value={formData.type || ''}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Descrição:
                <textarea
                  name="description"
                  value={formData.description || ''}
                  onChange={handleInputChange}
                />
              </label>
              <div className="button-container">
                <button type="submit">Salvar</button>
                <button type="button" onClick={handleEditToggle}>Cancelar</button>
              </div>
            </form>
          ) : (
            <>
              <h1>{pilula.title}</h1>
              <div className="completion-bar">
                <div className="completion-bar-filled" style={{ width: `${completionPercentage}%` }}>
                  {completionPercentage}%
                </div>
              </div>
              <p><strong>Tipo:</strong> {pilula.type}</p>
              <p><strong>Descrição:</strong> {pilula.description}</p>
              <div className="button-container">
                <button className="edit-button" onClick={handleEditToggle}>Editar</button>
                <button className="delete-button">Excluir</button>
                <button className="print-button">Imprimir</button>
              </div>
            </>
          )}
        </>
      ) : (
        <p>Pílula educacional não encontrada.</p>
      )}
    </div>
  );
}

export default PilulaDetails;
